import { useCallback, useMemo } from "react";
import { usePutRequest } from "../ApiWrappers/usePutRequest";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";

export const useActivateCloudStorage = () => {
    const {putRequest, reqestResponse, reqestError, reqestLoading} = usePutRequest();
    const baseUrl = useMemo(() => Config.GetConfigData().serviceUrl, []);
    const activateCloudStorage = useCallback((clinicId: string) => {
        const requestUrl = `${baseUrl}api/${v1}/clinic/${clinicId}/cloud-storage/activate`;
        logger.logInformation(`Request to Activate cloud strorage for the given clinic ${clinicId} was made`);
        putRequest<any>({},requestUrl);
    }, [baseUrl, putRequest]);

    return {reqestResponse, reqestError, reqestLoading, activateCloudStorage};
}